import api from "@/api";

export const filtrosService = {
  async listar() {
    const { data } = await api.get("/filtros");
    return data;
  },

  async getCount(filtroId) {
    const { data } = await api.get(`/filtros/${filtroId}/count`);
    return data;
  },

  async deletar(filtroId) {
    const { data } = await api.delete(`/filtros/${filtroId}`);
    return data;
  },

  async getRestaurantes() {
    const { data } = await api.get("/restaurantes");
    return data;
  },
};
